module.exports = __webpack_public_path__ + "static/media/path-bg@2x.84fee8bb.jpg";